import store from "web/redux/store";
import microsoftConsentMode from "web/script/analytics/microsoft-consent-mode";

export default {
    init: function () {
        // Set Consent Mode default state
        microsoftConsentMode.setDefaultConsentMode();
        // Update Consent Mode only if we already have consent cookies
        const state = store.getState().cookieConsentReducer;
        if (state.hasOwnProperty("acceptsAds") && state.hasOwnProperty("acceptsPersonalizedAds"))
            microsoftConsentMode.updateConsentMode(state);
    },

    send: function () {},
};
